<template>
  <div class="rightColumn">
    <RightColumnTopActionBar
      v-if="
        $store.state.conversation.activeConversation.ConversationID !== undefined
      "
    />
    <MessagesContainer />
    <transition name="fade">
      <div
        v-if="
          $store.state.conversation.activeConversation.uploaders !== undefined
        "
      >
        <ImageUploader
          v-if="
            isChatAttachmentUploadEnabled &&
            $store.state.conversation.activeConversation.uploaders.imageUploader
              .isVisible === true
          "
          :image-uploader="
            $store.state.conversation.activeConversation.uploaders.imageUploader
          "
          :conversation-i-d="
            $store.state.conversation.activeConversation.ConversationID
          "
        />

        <DocumentUploader
          v-if="
            isChatAttachmentUploadEnabled &&
            $store.state.conversation.activeConversation.uploaders.documentUploader
              .isVisible === true
          "
          :document-uploader="
            $store.state.conversation.activeConversation.uploaders.documentUploader
          "
          :conversation-i-d="
            $store.state.conversation.activeConversation.ConversationID
          "
        />
      </div>
    </transition>

    <EmojiKeyboard v-if="$store.state.display.emojiKeyboard.isShown" />
    <ReplyMessageBar />
    <InputMainBar
      v-if="
        $store.state.conversation.activeConversation.ConversationID !== undefined
      "
    />
    <NoActiveConversation
      v-if="
        $store.state.conversation.activeConversation.ConversationID === undefined
      "
    />
  </div>
</template>

<script>
import NoActiveConversation from './NoActiveConversation.vue'
import MessagesContainer from './messages/MessagesContainer.vue'
import ReplyMessageBar from './inputbar/ReplyMessageBar.vue'

const ImageUploader = () => import(/* webpackChunkName: "image-uploader" */ './uploaders/image/ImageUploader.vue')
const DocumentUploader = () => import(/* webpackChunkName: "document-uploader" */ './uploaders/image/DocumentUploader.vue')
const EmojiKeyboard = () => import(/* webpackChunkName: "emoji-keyboard" */ './inputbar/EmojiKeyboard.vue')
const InputMainBar = () => import(/* webpackChunkName: "input-main-bar" */ './inputbar/InputMainBar.vue')
const RightColumnTopActionBar = () => import(/* webpackChunkName: "conversation-header" */ './RightColumnTopActionBar.vue')

export default {
  computed: {
    isChatAttachmentUploadEnabled () {
      return process.env.VUE_APP_CHAT_ATTACHMENT_UPLOAD_ENABLED !== 'false'
    }
  },
  components: {
    RightColumnTopActionBar,
    InputMainBar,
    EmojiKeyboard,
    ReplyMessageBar,
    MessagesContainer,
    NoActiveConversation,
    ImageUploader,
    DocumentUploader
  }
}
</script>

<style scoped>
.rightColumn {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  position: relative;
  min-width: 600px;
  overflow: hidden;
}
</style>
